import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, type ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import { sortOnField } from "@rootreeweb/js-lib";
import { getLocalizedField } from "@rootreeweb/multi-language";
import type { Language } from "@rootreeweb/multi-language";
import { Heading2 } from "@rootreeweb/ui";

import type { FAQCategoryWithQuestions, FAQProps } from "../types.js";
import Question from "./Question.js";

type Props = {
	category: FAQCategoryWithQuestions;
	faqProps: FAQProps;
	lang: Language;
};

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Category(props: Props): ReactElement {
	const { category, faqProps, lang } = props;
	const title = getLocalizedField<string>(category, "label_", lang);
	const [open, setOpened] = useState(true);
	const questions = props.faqProps.alpha
		? sortOnField(
				category.questions,
				lang === "en" ? "question_en" : "question_fr",
			)
		: category.questions;
	return (
		<div className={"faq:mb-10"} data-testid="faq-category">
			{!faqProps.hide_title && (
				<button
					type="button"
					className="faq:border-0 faq:bg-transparent faq:p-0 faq:select-none faq:unset-all"
					onClick={() => setOpened(!open)}
				>
					<Heading2 className={"faq:mr-2 faq:mb-2"}>
						<span>{title}</span>
						{!faqProps.hide_accordion && (
							<FontAwesomeIcon
								icon={faAngleUp}
								className={twMerge(
									"faq:transition-all",
									open && "faq:rotate-180",
								)}
							/>
						)}
					</Heading2>
				</button>
			)}
			{open &&
				questions.map((q) => (
					<Question
						key={q.id}
						question={q}
						faqProps={faqProps}
						lang={props.lang}
					/>
				))}
		</div>
	);
}
